import { useState, useRef, useEffect } from "react"

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";
import Toast from '@base/Toast';
import { ButtonCancel, ButtonSave } from '@base/Button/ButtonForm'

import EscolaService from '@services/EscolaService'

export const ConsiderarNotaProfessorDialog = (props) => {
	const toastRef = useRef(null);

	const [loading, setLoading] = useState(false);
	const [considerarNotaProfessor, setConsiderarNotaProfessor] = useState(false);

	const buttonsSubmit = () =>
		<>
			<ButtonSave loading={loading} onClick={submit} />
			<ButtonCancel onBack={fecharModal} />
		</>

	const submit = () => {
		setLoading(true);

		EscolaService.considerarNotaProfessor(props.processo, props.codigoInep, !considerarNotaProfessor)
			.then(res => {
				toastRef.current.show("success", `${considerarNotaProfessor ? "Desconsideração" : "Consideração"} de Notas do Professor para a Escola Salvas com Sucesso!`);
				fecharModal();
			})
			.catch(error => toastRef.current.show("error", `Ocorreu um Problema ao Salvar ${considerarNotaProfessor ? "Desconsideração" : "Consideração"} de Notas do Professor para a Escola!`))
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		setLoading(true);

        EscolaService.listarPorCodigoInepOuEticket(props.processo, props.codigoInep)
			.then(resultado => {
				const { considerarNotaProfessor } = resultado.data;

				setLoading(false);
				setConsiderarNotaProfessor(considerarNotaProfessor);
			})
			.catch(error => toastRef.current.show("error", "Ocorreu um problema ao Buscar Informações da Escola!"));
	}, [props.processo, props.codigoInep]);

	const tituloModal = () => `${considerarNotaProfessor ? "Desconsideração" : "Consideração"} de Notas do Professor para a Escola ${props.codigoInep}`;

	const fecharModal = () => {
		props.handleClose();
		setConsiderarNotaProfessor(false);
	};

	return (
        <>
            <Toast ref={toastRef} />
			
			<Dialog
				maxWidth={"md"}
				fullWidth={true}
				closeDialog={props.handleClose}
				openDialog={props.open}
				title={tituloModal()}
				actions={buttonsSubmit()}
			>
				<Grid container spacing={3}>
					<Grid item lg={12}>
						{considerarNotaProfessor ? 
							<>Ao <b>Desconsiderar as Notas do Professor</b> para a Escola, serão retornadas as considerações para às <b>Notas Calculadas</b> como por padrão no sistema.</>
						:
							<>Ao <b>Considerar as Notas do Professor</b> para a Escola, as <b>Notas Calculadas serão ignoradas</b>, com excessão dos casos em que a Nota do Professor não tenha sido preenchida.</>
						}							
					</Grid>
				</Grid>
			</Dialog>
        </>
	);
}

export default ConsiderarNotaProfessorDialog;
